var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 10.4154C10.2288 10.4154 10.4154 10.2288 10.4154 9.9987C10.4154 9.76861 10.2288 9.58203 9.9987 9.58203C9.76861 9.58203 9.58203 9.76861 9.58203 9.9987C9.58203 10.2288 9.76861 10.4154 9.9987 10.4154Z",
    fill: "#2D3643",
    stroke: "#2D3643",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 15.2513C10.2327 15.2513 10.4193 15.0647 10.4193 14.8346C10.4193 14.6046 10.2327 14.418 10.0026 14.418C9.77252 14.418 9.58594 14.6046 9.58594 14.8346C9.58594 15.0647 9.77252 15.2513 10.0026 15.2513Z",
    fill: "#2D3643",
    stroke: "#2D3643",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 5.58333C10.2327 5.58333 10.4193 5.39678 10.4193 5.16667C10.4193 4.93655 10.2327 4.75 10.0026 4.75C9.77252 4.75 9.58594 4.93655 9.58594 5.16667C9.58594 5.39678 9.77252 5.58333 10.0026 5.58333Z",
    fill: "#2D3643",
    stroke: "#2D3643",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.9108456505410c1687ce6fd04b4c9afd.svg";
export { ForwardRef as ReactComponent };